import PrimeVue from "primevue/config";
import type { App, Plugin } from "vue";

// Services
import ConfirmationService from "primevue/confirmationservice";
import DialogService from "primevue/dialogservice";
import ToastService from "primevue/toastservice";

// Directives
import BadgeDirective from "primevue/badgedirective";
import Ripple from "primevue/ripple";
import StyleClass from "primevue/styleclass";
import Tooltip from "primevue/tooltip";

// Components
import ButtonGroup from "primevue/buttongroup";
import ConfirmDialog from "primevue/confirmdialog";
import FloatLabel from "primevue/floatlabel";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import RadioButton from "primevue/radiobutton";

// CSS
import "primeflex/primeflex.css";
// REMOVED: import "primeicons/primeicons.css"; // 242KB saved by using FontAwesome instead
import "primevue/resources/themes/lara-dark-blue/theme.css";

// Menu item links are aria-hidden; keep mouse clicks from focusing them so focus stays on the menu list.
const menuActionPt = {
    action: {
        onMousedown: (event: MouseEvent) => event.preventDefault(),
    },
};

const PrimeVuePlugin: Plugin = {
    install(app: App) {
        // Use PrimeVue
        app.use(PrimeVue, {
            pt: {
                card: {
                    content: {
                        class: "py-0",
                    },
                },
                menu: menuActionPt,
                contextmenu: menuActionPt,
            },
        });

        // Use Services
        app.use(ConfirmationService);
        app.use(DialogService);
        app.use(ToastService);

        // Use Directives
        app.directive("badge", BadgeDirective);
        app.directive("ripple", Ripple);
        app.directive("styleclass", StyleClass);
        app.directive("tooltip", Tooltip);

        // Use Components
        app.component("ButtonGroup", ButtonGroup);
        app.component("ConfirmDialog", ConfirmDialog);
        app.component("FloatLabel", FloatLabel);
        app.component("IconField", IconField);
        app.component("InputIcon", InputIcon);
        app.component("RadioButton", RadioButton);
    },
};

export default PrimeVuePlugin;
